import type {
  EquipmentContextQuestionnaire,
  EquipmentConfigurationWrite,
} from "../types/regulatory"
import { presentControls } from "./regulatoryPresentation"
import type { ICloudRegulatoryControlPoint } from "../types"
export function equipmentContextControls(
  data: EquipmentContextQuestionnaire,
): ICloudRegulatoryControlPoint[] {
  const labels = new Map(data.configuration.contexts.map((c) => [c.uuid, c.label]))
  const assignmentNames = new Map(
    data.configuration.contexts.flatMap((c) =>
      c.assignments.map(
        (a) =>
          [
            a.uuid,
            data.resolvedAssignments[a.uuid]?.templates.find(
              (t) => t.revisionUuid === a.templateRevisionUuid,
            )?.name ?? "Modèle",
          ] as const,
      ),
    ),
  )
  const mapped = new Map(
    Object.entries(data.resolvedAssignments).map(([id, resolved]) => [
      id,
      new Map(presentControls(resolved).map((p) => [p.PointRevisionUUID, p])),
    ]),
  )
  return data.controls
    .filter((c) => c.displayContextUuid === c.answerContextUuid)
    .map((c) => {
      const primary = c.sources[0]!
      const point = mapped.get(primary.assignmentUuid)?.get(c.pointRevisionUuid)
      if (!point) throw new Error("Définition de contrôle absente du contexte")
      const classifications = c.sources.map(
        (s) =>
          mapped.get(s.assignmentUuid)?.get(c.pointRevisionUuid)?.DisplayCategory?.code ??
          "unclassified",
      )
      const conflict = new Set(classifications).size > 1
      const shared = data.controls
        .filter(
          (p) =>
            p.answerContextUuid === c.answerContextUuid &&
            p.pointUuid === c.pointUuid &&
            p.displayContextUuid !== p.answerContextUuid,
        )
        .map((p) => labels.get(p.displayContextUuid) ?? p.displayContextUuid)
      return {
        ...point,
        CompositionEnabled: data.configuration.enabled,
        AnswerContextUUID: c.answerContextUuid,
        ContextLabel: labels.get(c.answerContextUuid),
        SharedWith: Array.from(new Set(shared)),
        SourceAssignments: Array.from(
          new Set(c.sources.map((s) => assignmentNames.get(s.assignmentUuid) ?? s.assignmentUuid)),
        ),
        ClassificationConflict: conflict,
        ClassificationReviewed: conflict ? false : point.ClassificationReviewed,
      }
    })
}
export function configurationDraftKey(body: EquipmentConfigurationWrite) {
  return JSON.stringify(body)
}
